"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PILL_CATEGORY_KEY = 'base';
exports.PILL_COMPONENT_KEY = 'pill';